import { pushFbqCustomEvent } from '@/utils/fbqTrack'
import { useFbRuntimeConfig } from '@/composables/fbq/useFbRuntimeConfig'

export function useFbqReadChapter() {
  const { isEventEnabled, getEventConfig } = useFbRuntimeConfig()

  function reportReadChapter(
    contentId: string | number,
    chapterId: string | number,
    chapterNo: number,
    firstPaidChapterNo: number | null,
  ) {
    if (!isEventEnabled('READ_CHAPTER'))
      return

    const eventConfig = getEventConfig('READ_CHAPTER')
    const targetValue = eventConfig?.targetValue ?? 0

    if (eventConfig?.targetType === 'EXACT_CHAPTER') {
      if (chapterNo !== eventConfig.targetValue)
        return
    }
    else if (eventConfig?.targetType === 'FIRST_PAID_CHAPTER') {
      if (firstPaidChapterNo === null || chapterNo !== firstPaidChapterNo)
        return
    }
    else if (eventConfig?.targetType === 'FIRST_PAID_CHAPTER_PLUS') {
      if (firstPaidChapterNo === null || chapterNo !== firstPaidChapterNo + targetValue)
        return
    }
    else if (eventConfig?.targetType === 'FIRST_PAID_CHAPTER_MINUS') {
      if (firstPaidChapterNo === null || chapterNo !== firstPaidChapterNo - targetValue)
        return
    }

    pushFbqCustomEvent('ReadChapter', {
      content_id: String(contentId),
      chapter_id: String(chapterId),
      chapter_no: String(chapterNo),
      is_unlocked: '1',
    }, 'fb_read_chapter')
  }

  return { reportReadChapter }
}
